import { BtnGroup, BtnToolbar, Button, ButtonAction, PageTitle } from '@dec/shared';
import { Transparency } from 'react-bootstrap-icons';
import { useNavigate, useParams } from 'react-router-dom';

import { DisbursementCard } from '../components/DisbursementCard';
import { DisbursementTransactionsCard } from '../components/DisbursementTransactionsCard';

export const DisbursementViewPage = () => {
  // se recupera el identificador del pago
  const { id } = useParams();

  const navigate = useNavigate();

  const onReturn = () => {
    const url = '/disbursement/view';
    navigate(url);
  };

  return (
    <>
      <PageTitle title="Disbursement" subtitle="Between jurisdictions" icon={Transparency} />

      <DisbursementCard id={id!} />

      <DisbursementTransactionsCard id={id!} />

      <BtnToolbar>
        <BtnGroup>
          <Button action={ButtonAction.return} variant="secondary" onClick={onReturn} />
        </BtnGroup>
        <BtnGroup> </BtnGroup>
      </BtnToolbar>
    </>
  );
};
